<template>
  <div id="end-confirm">
    <ipub-model title=""
                width="300px"
                :visable="isVisable"
                :showHeader="false"
                :showFooter="false"
                @cancel="cancel">
      <div class="content-center"
           style="">
        <ipub-icon type="iconDetails"
                   style="font-size:60px"
                   class="key-color"></ipub-icon>
        <div class="ipub-h3 content-center"
             style="width:300px">
          H-Index is empty!
        </div>
        <div class="ipub-p2 content-center">The reviewer’s ({{inputData.firstName}} {{inputData.lastName}} {{inputData.email}}）H-Index is empty, please add the index below; after that, the reviewer can be invited.</div>
        <div class="mar-b-20 flex-center">
          <div class="line-h-40">
            H-index <font class="key-color">*</font>
          </div>
          <ipub-input class="mar-l-20 tl"
                      number
                      v-model="hindex" />
        </div>
        <div class="tc">
          <ipub-button type="primary"
                       plain
                       style="width:120px"
                       @click="cancel">
            Cancel
          </ipub-button>
          <ipub-button :disabled="!hindex"
                       type="primary"
                       style="width:120px"
                       @click="confirm">
            Confirm
          </ipub-button>
        </div>
      </div>

    </ipub-model>
  </div>
</template>

<script>
import person from '@/api/person'

export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      hindex: ''
    }
  },
  methods: {
    async confirm () {
      if (!this.hindex) {
        this.$message.error({
          title: 'Error',
          content: 'Please fill in h index first!'
        })
        return
      }
      let { personId, version } = this.inputData
      await person.hindex(personId, {
        hindex: this.hindex,
        version
      })
      this.inputData.hindex = this.hindex
      this.$message.success({
        title: 'Success',
        content: 'The reviewer‘s H-index has been added!'
      })
      this.$emit('confirm', this.inputData, this.inputData.__index)
    },
    cancel () {
      this.$emit('cancel')
    },
  }
}
</script>

<style lang="scss" scoped>
.content-center {
  margin: 0 auto 20px;
  text-align: center;
}
</style>
